export default __webpack_public_path__ + "static/media/mt1.bb29cc34.png";